import dayjs from 'dayjs';

/**
 * Splits the distance between `date` and now into a value and the largest unit
 * that fits, for handing to `Intl.RelativeTimeFormat` (via the `relative_time`
 * locale key) rather than building a display string here.
 *
 * Past dates come back negative, future dates positive — the sign convention
 * `Intl.RelativeTimeFormat` expects.
 */
export function getRelativeTime(date: Date): [number, 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year'] {
  const diffInSeconds = dayjs(date).diff(Date.now(), 'second');
  const second = 1;
  const minute = 60 * second;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;
  const intervals = { second, minute, hour, day, month, year };

  const units = Object.keys(intervals) as ('second' | 'minute' | 'hour' | 'day' | 'month' | 'year')[];
  for (let i = 0; i < units.length; i++) {
    const nextInterval = intervals[units[i + 1]];
    if (nextInterval && Math.abs(diffInSeconds) < nextInterval || !nextInterval) {
      const unit = units[i];
      const interval = intervals[unit];
      const value = Math.round(Math.abs(diffInSeconds) / interval);
      return [diffInSeconds < 0 ? -value : value, unit];
    }
  }
}
